module.exports = __webpack_public_path__ + "img/dispatch-icon-3.90be5b43.png";